(function($) {


	var wow = new WOW(
      {
  		mobile: false
    }
    )
    wow.init();

	//universal vars
	var 	siteHeader = $('header.site-header'),
			backgroundwrapper = $('.background-wrapper'),
			scrollDistance = $(window).scrollTop(),
			loadWidth = $(window).width();

	$(document).ready(function(){

		$('.testimonials-slider').slick({
			  dots: false,
			  infinite: true,
			speed: 300,
			slidesToShow: 1,
			responsive: [
			    {
			      breakpoint: 767,
			      settings: {
					prevArrow: '<button class="button tertiary-button previous-button">< Previous</button>',
					nextArrow: '<button class="button tertiary-button next-button">Next ></button>',
			      }
			    }
			  ]
		});

		// $('.homepage-slider').slick({
		//   dots: true,
		//   infinite: false,
		//   speed: 1000,
		//   slidesToShow: 1,
		//   arrows: true,
		//   adaptiveHeight: false,
		//   autoplay: true,
		//   fade: true
		// });

		$('.product-gallery-slides').slick({
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			adaptiveHeight: false,
			arrows: false,
			centerMode: false,
			variableWidth: false
		});

		$('.related-posts-slider').slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			adaptiveHeight: false,
			arrows: true,
			centerMode: true,
			variableWidth: false,
			centerPadding: '20%',
			responsive: [
			    {
			      breakpoint: 767,
			      settings: {
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 1,
					arrows: true,
					centerMode: false,
					prevArrow: '<button class="button secondary-button previous-button">< Previous</button>',
					nextArrow: '<button class="button secondary-button next-button">Next ></button>',
					centerPadding: '0%',
			      }
			    }
			  ]
		});
	});

	$(window).on('load',function() {
	  	parallaxSetup(backgroundwrapper);
	  	parallaxScroll(scrollDistance,backgroundwrapper);
	  	//adjust page content padding
		//pageContentPadding();
		sizeBoxes('.service-single-loop');
		sizeBoxes('.article-details h3');
		sizeBoxes('.entry-excerpt');
		sizeBoxes('.single-button-row h3');
		sizeBoxes('.product-wrapper');
		sizeBoxes('.tab-button-wrapper');
		sizeBoxes('.product-benefits-section .benefit-content');

		if($(window).width() > 768) {
		sizeBoxes('.homepage-icon-section .info-section-single .content-side');
		}
		
		hideText('.info-section-single .content-side .hidden-mobile');
		// Animate loader off screen
	    $("#loader").fadeOut("slow");
	});

	var resizeTimer;

	$(window).on('resize', function(e) {

	  clearTimeout(resizeTimer);
	  resizeTimer = setTimeout(function() {

	  parallaxSetup(backgroundwrapper);
	  parallaxScroll(scrollDistance,backgroundwrapper);

	  if($(window).width() > 768) {
		sizeBoxes('.homepage-icon-section .info-section-single .content-side');
		}
	else {
		$('.homepage-icon-section .info-section-single .content-side').css('height','auto');
	}
	            
	  }, 250);

	  if($('#off-canvas').hasClass('is-open')) {
	  		location.reload();
		}

	});

	$(window).scroll(function() {
		scrollDistance = $(window).scrollTop();

		//pageContentPadding();
		parallaxScroll(scrollDistance,backgroundwrapper);
		stickyHeaderClass(scrollDistance,150,siteHeader);
	  
	});

	//parallax setup
	var parallaxSetup = function(parallaxSelector) {
	var backgroundWrapper = $(parallaxSelector); // find all the parallax backgrounds

	$(backgroundWrapper).each(function(index){
			var backgroundWrapperTop = $(this).offset(), //element's distance from the top
				backgroundWrapperHeight = $(this).innerHeight(); //element's height

			$(this).data('top-distance', backgroundWrapperTop.top);
			$(this).data('element-height', backgroundWrapperHeight);
			});
		};

	//parallax animation
	var parallaxScroll = function(scrollDistanceMonitor,$backgroundWrapper){
		//parallax bg
		$($backgroundWrapper).each(function(index){
			var backgroundWrapperImage = $(this).children('img'), //the image within the element
			    topDistance = $(this).data('top-distance'),
			    elementHeight = $(this).data('element-height'),
			    bottomOfElement = topDistance - elementHeight,
			    scrollSet = 0 - 50 + ((scrollDistanceMonitor - bottomOfElement) / 100);

			if(scrollDistanceMonitor >= (bottomOfElement)) {
				backgroundWrapperImage.css('transform', 'translate(-50%,' + scrollSet + '%)');
			}

		})
	};

	//sticky header function
	var stickyHeaderClass = function(scrollDistanceMonitor, classDistance, headerSelector){
		if(scrollDistanceMonitor > classDistance) {
			$(siteHeader).addClass('scrolled');
		}
		else {
			$(siteHeader).removeClass('scrolled');
		}
	};

	var sizeBoxes = function(boxSelector){
		var boxSize = 0;

		$(boxSelector).each(function(index){
			var heightSet = $(this).innerHeight();
			if(heightSet > boxSize) {
				boxSize = heightSet;
			}
		});
		//if($(window).width() > 767) {
			$(boxSelector).css('height', boxSize + 'px');
		//}
		//console.log(boxSize);
	};

	// a function to hide icon text on mobile 
	var hideText = function(targetElement) {

	var targetLi = $(targetElement).find('ul > li'),
		targetP = $(targetElement).find('p');

			targetLi.addClass('toggle-these');
			targetP.addClass('toggle-these');
			$(targetElement).find('ul:first-child > li:first-child').removeClass('toggle-these');
			$(targetElement).find('p:first-child').removeClass('toggle-these');


		if($(window).width() < 768) {	
			$('.toggle-these').hide();	
		}

		else {
			$('.toggle-these').show();
		}

		$('.hidden-mobile .toggle-button').on('click', function(){
			var buttonOuter = $(this).parents('.hidden-mobile'),
				targetThis = $(buttonOuter).find('.toggle-these');

			targetThis.slideToggle();

		});

	}

	$(window).on('resize', function(){
		if ($(this).width() !== loadWidth) {
			hideText('.info-section-single .content-side .hidden-mobile');
		}
		if($(window).width() < 768) {
			$('.homepage-posts-loop').slick({
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				arrows: true,
				prevArrow: '<button class="button tertiary-button previous-button">< Previous</button>',
				nextArrow: '<button class="button tertiary-button next-button">Next ></button>',
			});
		}
		else {
			if($('.homepage-posts-loop').hasClass('slick-initialized')) {
				$('.homepage-posts-loop').slick('unslick');
			}
		}
	}).resize();


//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    $('input.search-field').val("");
    event.stopPropagation();
});


$(document).on('click' , function(e){
    var $menu = $('.nav-primary'),
        $targetBody = $('body'),
        $menuButton = $('.menu-toggle'),
        $searchOverlayForm = $('.search-overlay-form'),
        $searchOverlay = $(".search-overlay"),
        $menuSearchButton = $('.menu-search a');

    // When the search menu is open this will close it on click outside form
    if (!$searchOverlayForm.is(e.target) // if the target of the click isn't the container...
    && $searchOverlayForm.has(e.target).length === 0 && !$menuSearchButton.is(e.target) && $targetBody.hasClass('search-open')) 
    // ... nor a descendant of the container

    {       event.preventDefault();
            $($targetBody).removeClass('search-open');
            event.stopPropagation();
    }
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 


// Photoswipe

var pswpElement = document.querySelectorAll('.pswp')[0];
var items = [];
var testitems = $('.product-gallery');

console.log(testitems);

testitems.each(function(){

	var productImages = $(this).find('.single-product-image > a'),
		thisItem = [];

	productImages.each(function(){
		var imageSrc = $(this).attr('href'),
			imageWidth = $(this).data('image-width'),
			imageHeight = $(this).data('image-height'),
			thisSlide = {
				src: imageSrc,
		        w: imageWidth,
		        h: imageHeight
			}

			thisItem.push(thisSlide);
	});

	items.push(thisItem);

});

$('.single-product-image > a').on('click', function(event){

	var clickedImage = $(this);
	event.preventDefault();
	var openPhotoSwipe = function() {
	var objectIndex = $(clickedImage).data('index');
	var objectParentIndex = $(clickedImage).data('parent-index');


	// define options (if needed)
	var options = {
	    // optionName: 'option value'
	    // for example:
	    bgOpacity: 0.75,
	    index: objectIndex, // start at first slide
	    closeEl:true,
		captionEl: true,
		fullscreenEl: true,
		zoomEl: true,
		shareEl: true,
		counterEl: true,
		arrowEl: true,
		preloaderEl: true

	};

	// Initializes and opens PhotoSwipe
	var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items[objectParentIndex], options);
	gallery.init();
	}

	openPhotoSwipe();

});

$('.image-zoom').on('click', function(event){
	var dataTarget = $(this).data('gallery');
	event.preventDefault();
	$(dataTarget).find('.slick-active.single-product-image a').trigger('click');
});

$('.product-info-accordion').on('up.zf.accordion', function() {
	var slideWidth = $('.accordion-item.is-active .product-gallery').width(),
	targetSlide = $('.accordion-item.is-active .product-gallery .slick-current.slick-active');
	// console.log($this)
	if(targetSlide.width() === 0) {
	targetSlide.css('width' , slideWidth + 'px');
	$('.accordion-item.is-active .slick-track').css('width' , (slideWidth * 2) + 'px');
	}
	 $('.accordion-item').removeClass('show-contents');
	 $('.accordion-item.is-active').addClass('show-contents');
});


	//animate all anchor links

	document.querySelectorAll('a[href^="#"].main-content-scroll').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

$(document).ready(function() {

  $('#headerVideoPlay').on('click', function(event) {
 	var videoPoster = $(this).children('.video-poster'),
 		videoPlay = $(this).children('.video-play'),
 		videoiFrame = $(this).find('iframe');

 		videoPoster.fadeOut(300, function(){
 			videoPlay.fadeIn(300);
 		});

 		videoiFrame[0].src += "&autoplay=1";
 		
    //$("#video")[0].src += "&autoplay=1";
    event.preventDefault();
 
  });

  $('#headerVideo').on('click', function(event) {
  	$('#headerVideoPlay').click();
  	event.preventDefault();
  });

 $(document).ready(function () {
    $('#customer-table').DataTable({
        lengthMenu: [
            [100, 150, 250, -1],
            [100, 150, 250, 'All'],
        ],
    });
});
});

$('.play-video-self').on('click',function(){
	 event.preventDefault();
	 var videoPlay = $(this).data('video-play'),
	 	videoElement = $(videoPlay).find('video');

	 	videoElement[0].play();

});
	
})( jQuery );